import React from 'react';
import {observer} from 'mobx-react';

//helpers
import {styleable} from 'decorators';
import {useStore} from 'hooks/useStore';
import {applyMetadata} from 'utils/image-utils';
import {
  getCloudinaryImageUrl,
  getFixedExtensionFromUrl,
  getThumbnail,
  getVideoPlaybackUrl,
  isVideoUrl
} from 'utils/media-utils';
import omit from 'lodash/omit';

//components
import CloudinaryPicture from 'components/CloudinaryPicture';
import {VideoPlayerMobile} from 'components/VideoPlayer';

const StepMediaComponent = ({
  autoplayVideo,
  imageSizes,
  mediaUrl,
  metadata = {},
  onClickMedia,
  optimizedVideos,
  refresh,
  shouldShowSpinnerWhileLoading
}) => {
  const isVideo = isVideoUrl(mediaUrl);
  const cloudinaryMediaUrl = isVideo
    ? getVideoPlaybackUrl(mediaUrl, {enableAudio: metadata && metadata.enableAudio, optimizedVideos})
    : getCloudinaryImageUrl(applyMetadata(mediaUrl, omit(metadata, 'focus')));

  if (isVideo) {
    return (
      <VideoPlayerMobile
        autoplayVideo={autoplayVideo}
        muted={!metadata.enableAudio}
        poster={getThumbnail(mediaUrl)}
        src={cloudinaryMediaUrl}
        type={'video/' + getFixedExtensionFromUrl(mediaUrl)}
      />
    );
  }

  return (
    <CloudinaryPicture
      onClick={() => {
        if (typeof onClickMedia === 'function') {
          onClickMedia({cloudinaryMediaUrl, metadata});
        }
      }}
      restartAnimation={refresh}
      shouldShowSpinnerWhileLoading={shouldShowSpinnerWhileLoading}
      shouldShowOverlayShapes={true}
      aspectRatio={4 / 3}
      metadata={metadata}
      src={mediaUrl}
      sizes={imageSizes}
    />
  );
};

const StyleableStepMedia = styleable(StepMediaComponent);

export default observer(props => {
  const {platform} = useStore();
  return <StyleableStepMedia {...props} optimizedVideos={platform.hasOptimizedVideos} />;
});
